import { render } from "./MessageOptions.vue?vue&type=template&id=a7d32952"
import script from "./MessageOptions.vue?vue&type=script&lang=js"
export * from "./MessageOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__